import React from "react";

type ImageUploadProps = {
  value: string;
  onChange: (url: string) => void;
  uploadApi?: string; // endpoint upload, mặc định /api/Manage/UploadPosterImage
};

const ImageUpload: React.FC<ImageUploadProps> = ({
  value,
  onChange,
  uploadApi = "/api/Manage/UploadPosterImage",
}) => {
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await fetch(uploadApi, { method: "POST", body: formData });
      const data = await res.json();
      if (data.url) onChange(data.url);
    }
  };

  return (
    <div>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {value && (
        <img
          src={value}
          alt="preview"
          style={{ width: 60, height: 40, objectFit: "cover", marginTop: 8 }}
        />
      )}
    </div>
  );
};

export default ImageUpload;